import { hasGrayConfigWithoutGroup } from 'utils/gray';
import { adaptMpcExternalOuterPath } from '@mpc/common/src/utils/axios';

export const getAttachementDownloadLink = (
  attachId: number,
  withDownload = true
) => {
  let query = '';

  if (withDownload) {
    query = '?download=attachment';
  }

  if (hasGrayConfigWithoutGroup(['external.supplier_attaches_download'])) {
    return adaptMpcExternalOuterPath(`/api/outsource/v2/java_proxy/attachments/${attachId}${query}`);
  }

  return `api/v1/attachments/${attachId}${query}`;
};

export const getAttachementUploadUrl = () => {
  if (hasGrayConfigWithoutGroup(['external.supplier_attaches_upload'])) {
    return adaptMpcExternalOuterPath(`/api/outsource/v2/java_proxy/attachments/upload`);
  }

  return `/api/v1/attachments/upload`;
};
